module.exports = __webpack_public_path__ + "media/images/sp/stores/horie/horie_sns_02-8ee81d912775a8f1ef42e3d073f71def.jpg";